import { type ReactNode, type ComponentPropsWithoutRef } from 'react';
import { createPath, type To } from 'react-router';
import { useNavigate } from '../routing/navigate';

export interface LinkProps extends Omit<ComponentPropsWithoutRef<'a'>, 'href'> {
  replace?: boolean;
  to: To;
}

export function Link({ children, onClick, replace, to, ...props }: LinkProps): ReactNode {
  const navigate = useNavigate();

  const onClickHandler = (event: React.MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    event.preventDefault();
    navigate(to, { replace });
  };

  const url = typeof to === 'string' ? to : createPath(to);

  return (
    <a href={url} onClick={onClickHandler} {...props}>
      {children}
    </a>
  );
}
